import { Injectable } from '@angular/core';
import { DrawerRef, DrawerService, DrawerSize } from 'app/shared/services/drawer';
import { CustomerDetailDrawerComponent } from './customer-detail-drawer.component';
import { CustomerDetailDrawerData } from './customer-detail-drawer.types';

/**
 * Service for opening the Customer Detail Drawer from anywhere in the application.
 *
 * @example
 * ```typescript
 * // In your component
 * private customerDrawer = inject(CustomerDetailDrawerService);
 *
 * openCustomerDetail(customerId: string): void {
 *   this.customerDrawer.open(customerId);
 * }
 * ```
 */
@Injectable({
  providedIn: 'root',
})
export class CustomerDetailDrawerService {
  constructor(private readonly drawerService: DrawerService) {}

  /**
   * Opens the customer detail drawer for the specified customer.
   *
   * @param customerId The MongoDB ObjectId of the customer/business partner
   * @returns DrawerRef for controlling the drawer
   */
  open(customerId: string, companyId?: string): DrawerRef<void> {
    const data: CustomerDetailDrawerData = { customerId, companyId };

    return this.drawerService.open<void, CustomerDetailDrawerData>(CustomerDetailDrawerComponent, {
      data,
      size: DrawerSize.LARGE,
      hasBackdrop: true,
    });
  }
}
